import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import state from './root/rootState'
import mutations from './root/rootMutations'
import actions from './root/rootActions'
import getters from './root/rootGetters'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

const store = new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    strict: debug,
    plugins: [vuexLocal.plugin]
})

export default store
